module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f6QiM"))).then(() => parcelRequire('hEqeo'));